/* eslint-disable */

import React from 'react';

export default function WireframeTapBarMobile(props: { tabBarClassName: string }) {
    /**
     * Effect: Fix TapBar positioning on safari after burger menu was closed
     */
    const wasTapBarFixedRef = React.useRef(false);
    React.useEffect(() => {
        if (!window.C24M?.navi || wasTapBarFixedRef.current) {
            return;
        }

        const prevClosed = window.C24M.navi.closed;

        // eslint-disable-next-line fp/no-mutation
        window.C24M.navi.closed = () => {
            prevClosed();
            window.Check24?.hideTapBar();
            setTimeout(() => {
                window.Check24?.showTapBar();
            }, 400);
        };

        wasTapBarFixedRef.current = true;
    }, []);

    return (
        <>
            <style
                jsx
                global
            >{`
                // Fix, override otherwise tab bar would use indi body styles
                .c24m-tap-bar {
                    font-size: 12px;
                    line-height: 16px;
                    -webkit-font-smoothing: auto;
                }
            `}</style>
            <div className={`c24m-tap-bar ${props.tabBarClassName ?? ''}`}>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-start `}
                    href={`https://m.check24.de/`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M24.484,9.651L15.087,1.882c-.632-.51-1.549-.511-2.181.002L3.518,9.645c-.271.22-.427.544-.427.89l.002,15.094c0,.48.391.871.87.871h8.127v-7.85c0-.149.12-.27.27-.27h3.28c.149,0,.27.12.27.27v7.85h8.127c.479,0,.87-.391.87-.871l-.003-13.535.006-1.55c0-.35-.154-.676-.425-.894ZM23.087,24.68c-.051.051-.12.079-.191.079h-4.976c-.149,0-.27-.12-.27-.27v-6.98c0-.479-.391-.87-.87-.87h-5.562c-.479,0-.87.391-.87.87v6.98c0,.149-.12.27-.27.27h-4.976c-.149,0-.27-.12-.27-.27l-.003-13.176c0-.165.073-.32.202-.426L13.821,3.607c.1-.082.244-.082.344,0l8.796,7.284c.128.104.202.259.202.426l.002,13.172c0,.071-.028.141-.078.19Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Start"
                    >
                        Start
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-activity `}
                    href={`https://m.check24.de/kundenbereich/?o=activitylist`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M21.822,26.5H6.178c-2.285,0-4.145-1.859-4.145-4.145V5.645C2.033,3.359,3.892,1.5,6.178,1.5h15.644c2.285,0,4.145,1.859,4.145,4.145v16.709c0,2.286-1.86,4.145-4.145,4.145ZM6.178,3.191c-1.354,0-2.455,1.101-2.455,2.455v16.709c0,1.354,1.101,2.455,2.455,2.455h15.644c1.354,0,2.455-1.101,2.455-2.455V5.645c0-1.354-1.101-2.455-2.455-2.455H6.178Z"></path>
                            <g>
                                <path d="M16.306,10.227H7.97c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h8.336c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                                <path d="M13.963,14.845h-5.993c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h5.993c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                                <path d="M12.592,19.464h-4.622c-.467,0-.845-.378-.845-.845s.378-.845.845-.845h4.622c.467,0,.845.378.845.845s-.378.845-.845.845Z"></path>
                            </g>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Aktivit&auml;ten"
                    >
                        Aktivit&auml;ten
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-newsfeed `}
                    href={`https://newsfeed.check24.de/`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M16.625,23.165c-.213-.071-.449-.059-.662.035-.213.095-.367.272-.438.485-.237.65-.851,1.088-1.549,1.088s-1.313-.438-1.549-1.088c-.154-.449-.65-.686-1.1-.532-.213.071-.39.225-.485.438-.106.213-.118.449-.035.662.473,1.348,1.75,2.247,3.169,2.247s2.696-.899,3.169-2.247c.154-.449-.083-.946-.532-1.1h0l.012.012h0Z"></path>
                            <path d="M24.998,17.524l-.142-.142c-1.62-1.62-2.507-3.772-2.507-6.055v-1.514c0-2.093-.769-4.092-2.176-5.629-.058-.064-.116-.126-.176-.188-1.565-1.622-3.75-2.497-6.004-2.497h-.046c-1.548,0-3.078.402-4.392,1.221-.643.401-1.234.892-1.752,1.464-1.407,1.537-2.176,3.548-2.176,5.629v1.514c0,2.247-.911,4.458-2.507,6.043l-.142.142c-.438.438-.686,1.041-.686,1.656,0,1.289,1.053,2.342,2.342,2.342h18.723c1.296,0,2.353-1.049,2.351-2.345-.002-1.273-.25-1.204-.686-1.64h-.024ZM14.047,3.167c3.631.035,6.563,3.004,6.563,6.634v1.514c0,2.708,1.1,5.357,3.016,7.273l.142.142c.098.098.156.221.172.355.047.382-.265.697-.649.697H4.622c-.331,0-.615-.272-.615-.615s.059-.319.177-.438l.142-.142c1.939-1.939,3.016-4.518,3.016-7.273v-1.514c0-3.666,2.98-6.634,6.634-6.634h.071Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Mitteilungen"
                    >
                        Mitteilungen
                    </div>
                </a>
                <a
                    className={`c24m-tap-bar-option c24m-tap-bar-option-overview `}
                    href={`https://m.check24.de/kundenbereich/?o=overview`}
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path d="M14,14.485c3.58,0,6.493-2.912,6.493-6.492s-2.913-6.493-6.493-6.493-6.493,2.913-6.493,6.493,2.913,6.492,6.493,6.492ZM14,3.199c2.644,0,4.794,2.15,4.794,4.794s-2.15,4.793-4.794,4.793-4.794-2.15-4.794-4.793,2.15-4.794,4.794-4.794Z"></path>
                            <path d="M17.434,16.219h-6.867c-3.874,0-7.025,3.151-7.025,7.026v2.405c0,.47.38.85.85.85s.85-.38.85-.85v-2.405c0-2.938,2.39-5.327,5.326-5.327h6.867c2.937,0,5.326,2.39,5.326,5.327v2.405c0,.47.38.85.85.85s.85-.38.85-.85v-2.405c0-3.875-3.151-7.026-7.025-7.026Z"></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Profil"
                    >
                        Profil
                    </div>
                </a>
                <span
                    className={`c24m-tap-bar-option c24m-tap-bar-option-chat `}
                    data-qa-id="qa-tap-bar-option-chat"
                >
                    <div className={`c24m-tap-bar-icon`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                        >
                            <path
                                d="M16.772,8.984l1.278,4.309c.356,1.201,1.295,2.14,2.497,2.497l4.309,1.278c.452.134.452.774,0,.908l-4.309,1.278c-1.201.356-2.14,1.295-2.497,2.497l-1.278,4.309c-.134.452-.774.452-.908,0l-1.278-4.309c-.356-1.201-1.295-2.14-2.497-2.497l-4.309-1.278c-.452-.134-.452-.774,0-.908l4.309-1.278c1.201-.356,2.14-1.295,2.497-2.497l1.278-4.309c.134-.452.774-.452.908,0h0Z"
                                fill="#005c61"
                            ></path>
                            <path
                                d="M8.241,1.799l.744,2.511c.208.7.755,1.247,1.454,1.454l2.511.744c.263.078.263.451,0,.529l-2.511.744c-.7.208-1.247.755-1.454,1.454l-.744,2.511c-.078.263-.451.263-.529,0l-.744-2.511c-.208-.7-.755-1.247-1.454-1.454l-2.511-.744c-.263-.078-.263-.451,0-.529l2.511-.744c.7-.208,1.247-.755,1.454-1.454l.744-2.511c.078-.263.451-.263.529,0Z"
                                fill="#f07c00"
                            ></path>
                        </svg>
                    </div>
                    <div
                        className={`c24m-tap-bar-text`}
                        aria-label="Chat"
                    >
                        Chat
                    </div>
                </span>
            </div>
        </>
    );
}
